import {Injectable, OnDestroy, Renderer2, RendererFactory2} from "@angular/core";
import {fromEventPattern, Observable, Subject} from "rxjs";
import {takeUntilDestroy} from "take-until-destroy";
import {map} from "rxjs/operators";

/**
 ****************************************************************
 * Service class for catching window events.
 *
 * Created by Shai Zelman on 08/07/2020.
 ****************************************************************
 */
@Injectable({
	providedIn: "root"
})
export class WindowEventsService implements OnDestroy {
	public onClick: Observable<Event>;
	public get onScroll(): Observable<Event> {
		return this.scrollSubject.asObservable();
	}

	private scrollSubject: Subject<any> = new Subject<any>();

	constructor(private rendererFactory2: RendererFactory2) {
		const renderer = this.rendererFactory2.createRenderer(null, null);

		this.createOnClickObservable(renderer);
		this.createOnScrollObservable();
	}

	ngOnDestroy() {

	}

	private createOnClickObservable(renderer: Renderer2) {
		let removeClickEventListener: () => void;

		const createClickEventListener = (handler: (e: Event) => boolean | void) => {
			removeClickEventListener = renderer.listen("document", "click", handler);
		};

		this.onClick = fromEventPattern<Event>(createClickEventListener, () => removeClickEventListener()).pipe(takeUntilDestroy(this));
	}

	private createOnScrollObservable() {
		document.addEventListener('scroll', (e) => {
			this.scrollSubject.next(e);
		}, true);
	}
}
